export default __webpack_public_path__ + "static/media/content4.5c092dd1.jpg";